module.exports = __webpack_public_path__ + "static/media/logo-icon.db4c1a06.svg";